import axiosInstance from "../../utils/axiosInstance";

const RoleClient = {
  getAll: () => axiosInstance.get("/roles"),
  create: (payload) => axiosInstance.post("/roles", payload),
  update: (id, payload) => axiosInstance.put(`/roles/${id}`, payload),
  delete: (id) => axiosInstance.delete(`/roles/${id}`),
};

export default RoleClient;
